import { render } from "./productDetail.vue?vue&type=template&id=7210cb3a&scoped=true"
import script from "./productDetail.vue?vue&type=script&lang=js"
export * from "./productDetail.vue?vue&type=script&lang=js"

import "./productDetail.vue?vue&type=style&index=0&id=7210cb3a&lang=scss&scoped=true"

import exportComponent from "/Users/jinjing/Desktop/jj/code1/HM0518/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7210cb3a"]])

export default __exports__